// extracted by mini-css-extract-plugin
module.exports = {"richtext":"RichText_richtext__bfBZW","center":"RichText_center__stLmt","scale":"RichText_scale__rnC5U"};